import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Auth from '@aws-amplify/auth';
import { Link } from 'react-router-dom';
import defaultAvatar from 'static/images/default_avatar.png';
import Utils from 'helpers/utils';
import kamUtil from '@kambria/kambria-util';
import { connectWallet, watchInfo } from 'redux/actions/blockchain.action';
import './NavProfile.css';
import Web3 from 'web3';
import NftLicense from '../../pages/app/nft-licenses';

function NavProfile({ watchInfo, connectWallet, blockchain, user, karma, credit }) {
  const [toggle, setToggle] = useState(false);

  const onToggle = () => setToggle(!toggle);

  const onLogout = () => {
    localStorage.removeItem('pathBeforeSignIn');
    Auth.signOut().then(() => {
      window.cognitoAuth.signOut();
      if (window.kambriaWallet) window.kambriaWallet.logout();
      watchInfo();
    });
  };
  const [userWalletID, setuserWalletID] = useState(0);
  const [userNetworkId, setUserNetworkId] = useState(0);

  const connectMetamask = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        alert('Please finish the sign in process in MetaMask');
        const web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const networkId = await web3.eth.net.getId();
        setuserWalletID(accounts[0]);
        setUserNetworkId(networkId);
        let tokenContract;
        // Create the token contract instance
        if (networkId === 56) {
          tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
        } else if (networkId === 1) {
          tokenContract = new web3.eth.Contract(tokenABI2, tokenAddress2);
        } else {
          tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
        }
        // Call the balanceOf method on the token contract
        tokenContract.methods
          .balanceOf(accounts[0])
          .call()
          .then((balance) => {
            // The balance is returned as a big number, you may need to convert it to a readable format
            setTokenBalance(web3.utils.fromWei(balance, 'ether'));
          })
          .catch((error) => {
            console.error('Error fetching token balance:', error);
          });
      } catch (error) {
        console.error(error);
      }
    } else {
      alert('Please install MetaMask to use this feature');
    }
  };

  useEffect(() => {
    const checkAccounts = async () => {
      // Check if the window.ethereum object is available and connected
      if (window.ethereum) {
        try {
          const connectChecker = await window.ethereum.request({ method: 'eth_accounts' });

          if (connectChecker.length === 0) {
            // No accounts connected, handle it here
          } else {
            // Accounts are connected, handle it here

            const web3 = new Web3(window.ethereum);

            const networkId = await web3.eth.net.getId();
            // Request access to accounts

            setuserWalletID(connectChecker[0]);
            let tokenContract;
            // Create the token contract instance
            if (networkId === 56) {
              tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
            } else if (networkId === 1) {
              tokenContract = new web3.eth.Contract(tokenABI2, tokenAddress2);
            } else {
              tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
            }
            // Call the balanceOf method on the token contract
            tokenContract.methods
              .balanceOf(connectChecker[0])
              .call()
              .then((balance) => {
                // The balance is returned as a big number, you may need to convert it to a readable format
                setTokenBalance(web3.utils.fromWei(balance, 'ether'));
              })
              .catch((error) => {
                console.error('Error fetching token balance:', error);
              });
          }
        } catch (error) {
          // Handle any errors that occur during the request
          console.error('Error retrieving accounts:', error);
        }
      }
    };

    checkAccounts(); // Call the async function inside useEffect
  }, []);

  const { account, kat } = blockchain;
  const balance = (() => {
    const katAmount = Number(kamUtil.unit.wkat2KAT(kat || 0));
    const katBalance = (Math.round((katAmount + Number.EPSILON) * 100) / 100).toFixed(2);
    return `${Utils.formatNumber(katBalance) || 0} KAT`;
  })();
  const { firstName, lastName, name, email, avatarUrl } = user;
  const username = `${firstName || ''} ${lastName || ''}`.trim() || name || email;
  const userAvatarStyle = { backgroundImage: `url(${avatarUrl || defaultAvatar})` };
  const toggleClass = toggle ? 'open' : 'close';
  const karmaAmount = karma.amount ? `${karma.amount} KARMAS` : '0 KARMA';
  const creditAmount = credit.amount ? credit.amount : 0;

  const tokenAddress = '0x3A9eED92422ABdd7566fbA8C34Bb74b3f656DBb3';
  const tokenAddress2 = '0x14da230d6726C50F759Bc1838717F8CE6373509C';
  const walletAddress = userWalletID;
  const tokenABI = [
    { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
        { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
        { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
      ],
      name: 'Approval',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
        { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
        { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
      ],
      name: 'RoleAdminChanged',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { indexed: true, internalType: 'address', name: 'account', type: 'address' },
        { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
      ],
      name: 'RoleGranted',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { indexed: true, internalType: 'address', name: 'account', type: 'address' },
        { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
      ],
      name: 'RoleRevoked',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'address', name: 'from', type: 'address' },
        { indexed: true, internalType: 'address', name: 'to', type: 'address' },
        { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
      ],
      name: 'Transfer',
      type: 'event',
    },
    {
      inputs: [],
      name: 'ADMIN_ROLE',
      outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'MINTER_ROLE',
      outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'owner', type: 'address' },
        { internalType: 'address', name: 'spender', type: 'address' },
      ],
      name: 'allowance',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'spender', type: 'address' },
        { internalType: 'uint256', name: 'amount', type: 'uint256' },
      ],
      name: 'approve',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
      name: 'burn',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'decimals',
      outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'spender', type: 'address' },
        { internalType: 'uint256', name: 'subtractedValue', type: 'uint256' },
      ],
      name: 'decreaseAllowance',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'getOwner',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
      name: 'getRoleAdmin',
      outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { internalType: 'address', name: 'account', type: 'address' },
      ],
      name: 'grantRole',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { internalType: 'address', name: 'account', type: 'address' },
      ],
      name: 'hasRole',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'spender', type: 'address' },
        { internalType: 'uint256', name: 'addedValue', type: 'uint256' },
      ],
      name: 'increaseAllowance',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
      name: 'mint',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'receiver', type: 'address' },
        { internalType: 'uint256', name: 'amount', type: 'uint256' },
      ],
      name: 'mintTo',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'name',
      outputs: [{ internalType: 'string', name: '', type: 'string' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { internalType: 'address', name: 'account', type: 'address' },
      ],
      name: 'renounceRole',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'bytes32', name: 'role', type: 'bytes32' },
        { internalType: 'address', name: 'account', type: 'address' },
      ],
      name: 'revokeRole',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
      name: 'supportsInterface',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'symbol',
      outputs: [{ internalType: 'string', name: '', type: 'string' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'totalSupply',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'recipient', type: 'address' },
        { internalType: 'uint256', name: 'amount', type: 'uint256' },
      ],
      name: 'transfer',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'sender', type: 'address' },
        { internalType: 'address', name: 'recipient', type: 'address' },
        { internalType: 'uint256', name: 'amount', type: 'uint256' },
      ],
      name: 'transferFrom',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ];
  const tokenABI2 = [
    {
      constant: true,
      inputs: [],
      name: 'name',
      outputs: [{ name: '', type: 'string' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [
        { name: '_spender', type: 'address' },
        { name: '_value', type: 'uint256' },
      ],
      name: 'approve',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: true,
      inputs: [{ name: '_user', type: 'address' }],
      name: 'freezing',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: true,
      inputs: [],
      name: 'totalSupply',
      outputs: [{ name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [
        { name: '_from', type: 'address' },
        { name: '_to', type: 'address' },
        { name: '_value', type: 'uint256' },
      ],
      name: 'transferFrom',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: true,
      inputs: [],
      name: 'decimals',
      outputs: [{ name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [{ name: '_user', type: 'address' }],
      name: 'unfreeze',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: false,
      inputs: [
        { name: '_spender', type: 'address' },
        { name: '_subtractedValue', type: 'uint256' },
      ],
      name: 'decreaseApproval',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: true,
      inputs: [{ name: '_owner', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ name: 'balance', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [{ name: '_user', type: 'address' }],
      name: 'freeze',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: true,
      inputs: [],
      name: 'owner',
      outputs: [{ name: '', type: 'address' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: true,
      inputs: [],
      name: 'symbol',
      outputs: [{ name: '', type: 'string' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [
        { name: '_to', type: 'address' },
        { name: '_value', type: 'uint256' },
      ],
      name: 'transfer',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: false,
      inputs: [
        { name: '_spender', type: 'address' },
        { name: '_addedValue', type: 'uint256' },
      ],
      name: 'increaseApproval',
      outputs: [{ name: '', type: 'bool' }],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      constant: true,
      inputs: [
        { name: '_owner', type: 'address' },
        { name: '_spender', type: 'address' },
      ],
      name: 'allowance',
      outputs: [{ name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
    {
      constant: false,
      inputs: [{ name: 'newOwner', type: 'address' }],
      name: 'transferOwnership',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function',
    },
    { inputs: [], payable: false, stateMutability: 'nonpayable', type: 'constructor' },
    {
      anonymous: false,
      inputs: [
        { indexed: true, name: 'from', type: 'address' },
        { indexed: true, name: 'to', type: 'address' },
        { indexed: false, name: 'value', type: 'uint256' },
      ],
      name: 'Transfer',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, name: 'owner', type: 'address' },
        { indexed: true, name: 'spender', type: 'address' },
        { indexed: false, name: 'value', type: 'uint256' },
      ],
      name: 'Approval',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, name: 'owner', type: 'address' },
        { indexed: true, name: 'user', type: 'address' },
        { indexed: false, name: 'status', type: 'bool' },
      ],
      name: 'Freeze',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, name: 'previousOwner', type: 'address' },
        { indexed: true, name: 'newOwner', type: 'address' },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
  ];
  const [tokenBalance, setTokenBalance] = useState(null);

  return (
    <li className="sidebar">
      <button
        className="auth sidebar-toggle"
        style={userAvatarStyle}
        onClick={onToggle}
        id="sidebarMenuLink"
        data-toggle="sidebar"
        aria-haspopup="true"
        aria-expanded="true"
      >
        <span className={account ? 'success' : 'error'} />
      </button>
      <div className={`sidebar-menu sidebar-menu-right ${toggleClass}`} aria-labelledby="sidebarMenuLink">
        <div className="close-btn" onClick={onToggle}>
          ×
        </div>
        <div className="avatar item">
          <div className="icon" style={userAvatarStyle} />
          <div className="name">{username}</div>
          <div className="membership">Free Membership</div>
          {account ? (
            <span className="kat">{balance}</span>
          ) : userWalletID === 0 ? (
            <button className="not-login" onClick={() => connectMetamask()}>
              Connect your wallet to see Kat Balance
            </button>
          ) : (
            <p className="WalletDisplay">Connected to {userWalletID}</p>
          )}
          {/* <span style={{ color: "white", paddingLeft: "300px" }}> {creditAmount} CREDITS</span> */}
          <span className="CreditAmountDisplay">
            {creditAmount} CREDITS {tokenBalance !== null ? '- ' + Math.round(tokenBalance) + ' KAT' : ''}
          </span>
        </div>
        <div className="profile item">
          <Link to="/user/profile">Profile</Link>
        </div>
        <div className="balance item">
          <Link to="/user/account-balance">Account Balance</Link>
        </div>
        <div className="order-history item">
          <Link to="/user/order-history">Order History</Link>
        </div>
        <div className="order-history item">
          <Link to="/user/nft-licenses">NFT Licenses</Link>
        </div>
        <div className="order-history item">
          <Link to="/user/dao-info">DAO Info</Link>
        </div>
        {/* <div className="order-history item">
          <Link to="/user/token-portal">Token Portal</Link>
        </div> */}
        <div className="logout item">
          <span className="sidebar-item logout" onClick={onLogout}>
            Logout
          </span>
        </div>
      </div>
      <div id="overlay" className={toggleClass} onClick={onToggle}></div>
    </li>
  );
}

const mapStateToProps = ({ blockchain, user, karma, credit }) => ({ blockchain, user, karma, credit });
const mapDispatchToProps = { connectWallet, watchInfo };

export default connect(mapStateToProps, mapDispatchToProps)(NavProfile);
